<template>
  <v-card color="grey lighten-4"
    flat
    height="15px"
    tile>
    <v-toolbar app>
      <v-toolbar-side-icon></v-toolbar-side-icon>
      <v-toolbar-title class="headline text-uppercase">
          <span class="font-weight-light">Predict AAT</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
          flat
          href="https://www.tandfonline.com/doi/full/10.1080/15412555.2017.1401600"
          target="_blank">
        <span class="mr-2">Link to the article</span>
      </v-btn>
    </v-toolbar>
  </v-card>

</template>

<script>
  export default {
    data () {
      return {}
    }
  }
</script>

<style>
</style>
